import React, {Component} from 'react';

import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import DatePicker from "react-datepicker";
import SelectBox from "../../../etc/SelectBox"
import Popup from "../../../etc/Popup"

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";
import {
	getObjectLength,
	objectToQueryString,
	pushUrl,
	getNumberFormat,
	getSelectFormat
} from "../../../../utils/functions"

import {BASE_PATH, JOURNAL_FACET_NAME, FACET_ORDER} from "../../../../wpconfig"

import * as func from "../../../../utils/functions";

class CollegeItem extends Component {
	constructor(props) {
		super(props);
	}

	scrollMove = () => {
		let offset = 100;
		window.scrollTo({
			behavior: "smooth",
			top:
				document.getElementById(this.props.record.category_code).getBoundingClientRect().top -
				document.body.getBoundingClientRect().top - offset
		});
	}

	render() {
		const record = this.props.record;
		return (
			<div className="tab-nav-cell">
				<button type="button" className="btn-department-nav-item" onClick={this.scrollMove}>{record.category_name}</button>
			</div>
		)
	}
}

export default CollegeItem;

// College.propTypes = {
//     param : PropTypes.object,
//     facet : PropTypes.object,
// };
